import React from "react";
import Table from "../../FormFields/Table";

const MessageA19 = (props) => {
  const data = props.item && props.item.text && JSON.parse(props.item.text);
  // console.log("tableprops",data.headers,data.data);
  return <Table {...props} />;
};

export default MessageA19;
